import { render, staticRenderFns } from "./coupons.vue?vue&type=template&id=24f51127&scoped=true&"
import script from "./coupons.vue?vue&type=script&lang=js&"
export * from "./coupons.vue?vue&type=script&lang=js&"
import style0 from "./coupons.vue?vue&type=style&index=0&id=24f51127&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f51127",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Coupons: require('/app/components/coupons/coupons.vue').default})
